import {
    getRoles,
    getSlotAndTemplates,
} from "../services/dashboard/dashboard-services";
import { useEffect, useState } from "react";

const useGetFiltersData = () => {
    const [slotsAndTemplatesData, setSlotsAndTemplatesData] = useState([]);
    const [isAdmin, setIsAdmin] = useState(false);
    const [loading, setLoading] = useState(false);

    const fetchSlotsAndTemplatesData = async () => {
        try {
            setLoading(true);
            const result = await getSlotAndTemplates();
            setSlotsAndTemplatesData(result.data);
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };

    const fetchIsAdmin = async () => {
        try {
            const response = await getRoles();
            const roles = response.data.find((role) => role.name === "ADMIN");
            roles ? setIsAdmin(true) : setIsAdmin(false);
        } catch (error) {
            console.error("Error fetching role:", error);
        }
    };

    useEffect(() => {
        fetchSlotsAndTemplatesData();
        fetchIsAdmin();
    }, []);

    return [slotsAndTemplatesData, isAdmin, loading];
};

export default useGetFiltersData;
